import React, { Component } from 'react';
import { connect } from '~/redux/connect';
import { getAuthResult } from '~/stateGetter';
import { presentAuthError } from '~/statePresenter';
import { LoginForm } from '~/ui/LoginForm';
import { AuthLayout } from './AuthLayout';
import { Link } from "~/ui/Link/Link";

export class AuthPage extends Component {
    get hasError() {
        const error = this.props.error;
        return !(!error || !error.length)
    }

    get title() {
        let { trans } = this.props;
        if (this.hasError) return trans('loginPage.loginErrorTitle');
        return this.props.trans('loginPage.welcomeTitle')
    }

    get message() {
        let { trans, error } = this.props;
        if (this.hasError) return error;
        return trans('loginPage.welcomeMessage');
    }

    renderFooter = (color) => {
        return <Link href="/forgot_password" color={color} shouldPush>{this.props.trans("loginPage.forgotPassword")}</Link>
    }


    render() {
        return (
            <AuthLayout message={this.message} title={this.title} renderFooter={this.renderFooter}>
                <LoginForm />
            </AuthLayout>
        );
    }
}

const RXAuthPage = connect(
    (state) => {
        return {
            authResult: getAuthResult(state),
        };
    },
    (dispatch) => ({}),
    (props) => {
        return {
            error: presentAuthError(props.authResult),
        };
    }
)(AuthPage);

export default RXAuthPage;
